import { PlaceCenter } from '../PlaceCenter';
import { Spinner } from '../Spinner';

export const Fallback = () => (
  <PlaceCenter>
    <Spinner />
  </PlaceCenter>
);
